export default __webpack_public_path__ + "static/media/product_2.f4b1bfc3.webp";